'use client';

import { createContext, useContext, useMemo, useState } from 'react';

const AdminViewerBarContext = createContext(null);

export function AdminViewerBarProvider({ children }) {
  const [editHref, setEditHref] = useState('');

  const value = useMemo(() => ({ editHref, setEditHref }), [editHref]);

  return <AdminViewerBarContext.Provider value={value}>{children}</AdminViewerBarContext.Provider>;
}

export function useAdminViewerBar() {
  const ctx = useContext(AdminViewerBarContext);
  if (!ctx) throw new Error('useAdminViewerBar must be used within AdminViewerBarProvider');
  return ctx;
}
